import React from "react";
import ReactDOM from "react-dom";
import ModalPopup from "./ModalPopup";
import Profile from "../pages/Profile";

interface ProfilePopupProps {
  isOpen: boolean;
  onClose: () => void;
}

const ProfilePopup: React.FC<ProfilePopupProps> = ({ isOpen, onClose }) => {
  return ReactDOM.createPortal(
    <div
      className="profile-popup-container"
      style={{ position: "relative", zIndex: 10000 }}>
      <ModalPopup isOpen={isOpen} onClose={onClose}>
        <div className="profile-popup-content">
          <Profile />
        </div>
      </ModalPopup>
    </div>,
    document.body
  );
};

export default ProfilePopup;
